var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 34,
    viewBox: "0 0 30 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9512 18.061V11.4452C25.9512 6.45015 22.51 2.11445 17.646 0.978815C16.04 0.603741 14.3686 0.603741 12.7611 0.978815C7.89705 2.11445 4.4559 6.45015 4.4559 11.4452V18.061C4.4559 20.0793 3.74297 22.0335 2.44212 23.577L0.819756 25.5045C-0.00927547 26.4883 0.690266 27.9931 1.97772 27.9931H15.2021H28.4279C29.7153 27.9931 30.4149 26.4883 29.5858 25.5045L27.9635 23.577C26.6641 22.0335 25.9512 20.0793 25.9512 18.061Z",
    fill: "#FFB000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9312 27.8367C20.9312 30.9995 18.3667 33.564 15.2039 33.564C12.041 33.564 9.47656 30.9995 9.47656 27.8367C9.47656 24.6739 12.041 22.1094 15.2039 22.1094C18.3667 22.1079 20.9312 24.6724 20.9312 27.8367Z",
    fill: "#FFB000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.bfa1fba9a716122d342551c3346901bc.svg";
export { ForwardRef as ReactComponent };